export const siteInfo = {
  name: "看料入口",
  slogan: "一键直达，少绕弯直接看",
  intro:
    "看料入口是一个专注「快速抵达」的热点内容聚合门户。我们把分散在各处的新料、热料与分类内容整理成清晰的直达通道，免去层层查找，打开即可抵达感兴趣的内容分区。",
  email: "hello@kanliao-entry.example",
  cooperation: "bd@kanliao-entry.example",
  since: "2021",
};

export const navLinks = [
  { label: "直达通道", href: "#entry" },
  { label: "热门内容", href: "#hot" },
  { label: "分类浏览", href: "#category" },
  { label: "最新更新", href: "#latest" },
  { label: "常见问题", href: "#faq" },
  { label: "关于我们", href: "#about" },
];

export const heroKeywords = ["热点爆料", "娱乐动态", "生活见闻", "科技观察", "财经速览", "体育赛场"];

export const heroStats = [
  { value: "12,800+", label: "收录内容" },
  { value: "6", label: "主要分区" },
  { value: "0.8s", label: "平均响应" },
  { value: "免跳转", label: "直达体验" },
];

export const quickEntries = [
  {
    id: "e1",
    icon: "ri-fire-line",
    title: "热点爆料",
    desc: "正在发酵的讨论与现场直击，落地就能看清来龙去脉。",
    count: "3,240 条",
    href: "#category",
    category: "热点爆料",
  },
  {
    id: "e2",
    icon: "ri-movie-2-line",
    title: "娱乐动态",
    desc: "剧集、综艺与票房的第一手观察，更新节奏够快。",
    count: "2,180 条",
    href: "#category",
    category: "娱乐动态",
  },
  {
    id: "e3",
    icon: "ri-leaf-line",
    title: "生活见闻",
    desc: "烟火气里的真实记录，露营、咖啡、城市散步都在这里。",
    count: "2,760 条",
    href: "#category",
    category: "生活见闻",
  },
  {
    id: "e4",
    icon: "ri-cpu-line",
    title: "科技观察",
    desc: "新机、AI 与数码趋势，用大白话讲清关键变化。",
    count: "1,930 条",
    href: "#category",
    category: "科技观察",
  },
  {
    id: "e5",
    icon: "ri-line-chart-line",
    title: "财经速览",
    desc: "价格、消费与市场情绪的精简解读，通勤路上看完。",
    count: "1,460 条",
    href: "#category",
    category: "财经速览",
  },
  {
    id: "e6",
    icon: "ri-basketball-line",
    title: "体育赛场",
    desc: "联赛战报与赛场花絮，比分之外的细节同样好看。",
    count: "1,580 条",
    href: "#category",
    category: "体育赛场",
  },
];

export const categories = ["全部", "热点爆料", "娱乐动态", "生活见闻", "科技观察", "财经速览", "体育赛场"];

export const contentItems = [
  {
    id: "c1",
    category: "热点爆料",
    tag: "现场直击",
    title: "随手拍下的清晨街景，为何在一夜之间被反复转发",
    excerpt:
      "没有滤镜、没有脚本，一段普通的早高峰画面却让很多人停下手指。我们梳理了几个被反复提及的细节，看看共鸣从哪里来。",
    cover:
      "https://readdy.ai/api/search-image?query=Warm%20candid%20street%20photography%20of%20an%20early%20morning%20city%20street%20with%20soft%20golden%20light%20and%20gently%20blurred%20pedestrians%2C%20documentary%20editorial%20style%2C%20warm%20amber%20tones%2C%20clean%20balanced%20composition%2C%20high%20detail%2C%20calm%20atmosphere&width=800&height=560&seq=klc-01-street&orientation=landscape",
    readCount: "12.4万",
    date: "09-11",
    hot: 98,
  },
  {
    id: "c2",
    category: "热点爆料",
    tag: "社区话题",
    title: "一则社区通知引发讨论，居民最关心的其实是这样几件事",
    excerpt:
      "通知本身只有短短几行，评论区却聊了几百楼。我们把高频疑问归了归类，也许能解答你心里的同一个问题。",
    cover:
      "https://readdy.ai/api/search-image?query=Quiet%20residential%20community%20alley%20in%20soft%20afternoon%20light%20with%20greenery%20and%20warm%20brick%20walls%2C%20lifestyle%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20uncluttered%20composition%2C%20gentle%20shadows%2C%20high%20detail&width=800&height=560&seq=klc-02-community&orientation=landscape",
    readCount: "8.7万",
    date: "09-10",
    hot: 92,
  },
  {
    id: "c3",
    category: "娱乐动态",
    tag: "剧集观察",
    title: "新剧开播三天冲上热度榜首，观众评价为何两极分化",
    excerpt:
      "有人一口气追完，有人看了十分钟就关掉。差异到底出在节奏、台词还是选角？这篇帮你把争议点一次看清。",
    cover:
      "https://readdy.ai/api/search-image?query=Moody%20television%20drama%20still%20life%20with%20soft%20warm%20rim%20lighting%20and%20cinematic%20blurred%20background%2C%20cozy%20amber%20tones%2C%20editorial%20film%20style%2C%20elegant%20minimal%20composition%2C%20high%20detail&width=800&height=560&seq=klc-03-drama&orientation=landscape",
    readCount: "15.2万",
    date: "09-11",
    hot: 96,
  },
  {
    id: "c4",
    category: "娱乐动态",
    tag: "票房复盘",
    title: "暑期档票房复盘：口碑如何带动长线排片与二次观影",
    excerpt:
      "开局平淡的影片也有机会后来居上。我们看了排片曲线的变化，发现真正起作用的是这几类观众。",
    cover:
      "https://readdy.ai/api/search-image?query=Classic%20cinema%20hall%20interior%20with%20warm%20ambient%20lighting%20and%20soft%20focus%20seats%2C%20cinematic%20editorial%20photography%2C%20amber%20and%20cream%20tones%2C%20symmetrical%20clean%20composition%2C%20high%20detail&width=800&height=560&seq=klc-04-cinema&orientation=landscape",
    readCount: "9.9万",
    date: "09-09",
    hot: 88,
  },
  {
    id: "c5",
    category: "生活见闻",
    tag: "生活方式",
    title: "周末露营成年轻人新宠，装备清单里藏着这些门道",
    excerpt:
      "从帐篷到照明，新手最容易在预算上踩坑。我们按使用频率排了一份清单，帮你把钱花在真正高频的地方。",
    cover:
      "https://readdy.ai/api/search-image?query=Cozy%20weekend%20camping%20scene%20with%20a%20small%20tent%20and%20warm%20string%20lights%20at%20golden%20hour%2C%20outdoor%20lifestyle%20editorial%20photography%2C%20warm%20amber%20tones%2C%20softly%20blurred%20forest%20background%2C%20high%20detail&width=800&height=560&seq=klc-05-camping&orientation=landscape",
    readCount: "11.1万",
    date: "09-08",
    hot: 90,
  },
  {
    id: "c6",
    category: "生活见闻",
    tag: "小店故事",
    title: "小城咖啡馆的出圈秘诀：一杯手冲背后的三年坚持",
    excerpt:
      "没有网红装修，也没有大额投放，这家店靠回头客活了下来。老板聊了聊他怎么找到属于自己的客群。",
    cover:
      "https://readdy.ai/api/search-image?query=Small%20specialty%20coffee%20shop%20counter%20with%20pour%20over%20brewing%20and%20warm%20window%20light%2C%20lifestyle%20editorial%20photography%2C%20warm%20brown%20and%20cream%20tones%2C%20clean%20minimal%20composition%2C%20high%20detail&width=800&height=560&seq=klc-06-coffee&orientation=landscape",
    readCount: "6.3万",
    date: "09-07",
    hot: 82,
  },
  {
    id: "c7",
    category: "生活见闻",
    tag: "城市散步",
    title: "城市夜跑地图走红，跑友分享十条高人气路线",
    excerpt:
      "灯光、路况和补给点都会影响体验。十位跑友分别推荐了最熟悉的一段路，附上适合的时间段。",
    cover:
      "https://readdy.ai/api/search-image?query=City%20running%20path%20at%20dusk%20with%20warm%20street%20lights%20and%20a%20blurred%20runner%20in%20motion%2C%20urban%20lifestyle%20editorial%20photography%2C%20warm%20amber%20tones%2C%20clean%20composition%2C%20high%20detail&width=800&height=560&seq=klc-07-running&orientation=landscape",
    readCount: "5.8万",
    date: "09-06",
    hot: 79,
  },
  {
    id: "c8",
    category: "科技观察",
    tag: "新机抢先看",
    title: "国产手机新旗舰曝光：影像与续航双升级",
    excerpt:
      "这一代的变化主要集中在两处。我们对比了上代机型，列出真正影响日常使用的升级点。",
    cover:
      "https://readdy.ai/api/search-image?query=Modern%20smartphone%20product%20photography%20on%20a%20clean%20warm%20beige%20surface%20with%20soft%20studio%20light%2C%20minimal%20tech%20editorial%20style%2C%20warm%20neutral%20tones%2C%20subtle%20shadows%2C%20high%20detail&width=800&height=560&seq=klc-08-phone&orientation=landscape",
    readCount: "13.6万",
    date: "09-11",
    hot: 94,
  },
  {
    id: "c9",
    category: "科技观察",
    tag: "趋势解读",
    title: "AI 助手走进日常办公，是效率提升还是新的负担",
    excerpt:
      "用得好确实省时间，用不好反而多了一层返工。我们采访了几位重度使用者，总结出几条实用经验。",
    cover:
      "https://readdy.ai/api/search-image?query=Minimal%20desk%20workspace%20with%20a%20laptop%20showing%20abstract%20interface%20glow%20and%20a%20warm%20lamp%2C%20tech%20lifestyle%20editorial%20photography%2C%20warm%20neutral%20tones%2C%20clean%20uncluttered%20composition%2C%20high%20detail&width=800&height=560&seq=klc-09-ai&orientation=landscape",
    readCount: "10.4万",
    date: "09-05",
    hot: 86,
  },
  {
    id: "c10",
    category: "财经速览",
    tag: "消费指南",
    title: "新能源车价格区间再调整，普通家庭该如何挑选",
    excerpt:
      "价格变动常常伴随着配置微调。与其只盯数字，不如先想清楚自己每天真实的用车场景。",
    cover:
      "https://readdy.ai/api/search-image?query=Sleek%20electric%20car%20in%20a%20clean%20studio%20setting%20with%20warm%20soft%20lighting%2C%20automotive%20editorial%20photography%2C%20warm%20cream%20and%20amber%20tones%2C%20minimal%20composition%2C%20high%20detail&width=800&height=560&seq=klc-10-ev&orientation=landscape",
    readCount: "7.5万",
    date: "09-04",
    hot: 81,
  },
  {
    id: "c11",
    category: "体育赛场",
    tag: "战报",
    title: "老牌球队换帅后首秀，年轻球员表现亮眼引热议",
    excerpt:
      "阵型变化带来的是节奏上的提速。我们把关键的三十分钟单独拿出来分析，看看新体系跑不跑得通。",
    cover:
      "https://readdy.ai/api/search-image?query=Football%20stadium%20field%20at%20golden%20hour%20with%20warm%20stadium%20lights%20and%20empty%20green%20pitch%2C%20sports%20editorial%20photography%2C%20warm%20amber%20tones%2C%20wide%20clean%20composition%2C%20high%20detail&width=800&height=560&seq=klc-11-football&orientation=landscape",
    readCount: "8.1万",
    date: "09-03",
    hot: 84,
  },
  {
    id: "c12",
    category: "体育赛场",
    tag: "赛事焦点",
    title: "电竞联赛收官战爆冷，黑马战队让二追三逆袭夺冠",
    excerpt:
      "赛前几乎没人看好这支队伍。复盘三局调整之后，会发现胜负早在细节里埋下了伏笔。",
    cover:
      "https://readdy.ai/api/search-image?query=Esports%20arena%20with%20warm%20stage%20lighting%20and%20blurred%20gaming%20setup%2C%20competitive%20gaming%20editorial%20photography%2C%20warm%20amber%20and%20orange%20tones%2C%20dynamic%20clean%20composition%2C%20high%20detail&width=800&height=560&seq=klc-12-esports&orientation=landscape",
    readCount: "9.2万",
    date: "09-02",
    hot: 87,
  },
];

export const popularRanking = [
  { id: "r1", rank: 1, title: "新剧开播三天冲上热度榜首，观众评价为何两极分化", category: "娱乐动态", readCount: "15.2万" },
  { id: "r2", rank: 2, title: "国产手机新旗舰曝光：影像与续航双升级", category: "科技观察", readCount: "13.6万" },
  { id: "r3", rank: 3, title: "随手拍下的清晨街景，为何在一夜之间被反复转发", category: "热点爆料", readCount: "12.4万" },
  { id: "r4", rank: 4, title: "周末露营成年轻人新宠，装备清单里藏着这些门道", category: "生活见闻", readCount: "11.1万" },
  { id: "r5", rank: 5, title: "AI 助手走进日常办公，是效率提升还是新的负担", category: "科技观察", readCount: "10.4万" },
  { id: "r6", rank: 6, title: "暑期档票房复盘：口碑如何带动长线排片", category: "娱乐动态", readCount: "9.9万" },
];

export const latestItems = [
  { id: "l1", date: "09-11", time: "21:40", title: "国产手机新旗舰曝光：影像与续航双升级", category: "科技观察" },
  { id: "l2", date: "09-11", time: "18:05", title: "新剧开播三天冲上热度榜首，观众评价为何两极分化", category: "娱乐动态" },
  { id: "l3", date: "09-11", time: "10:22", title: "随手拍下的清晨街景，为何在一夜之间被反复转发", category: "热点爆料" },
  { id: "l4", date: "09-10", time: "20:15", title: "一则社区通知引发讨论，居民最关心的是这样几件事", category: "热点爆料" },
  { id: "l5", date: "09-10", time: "15:48", title: "电竞联赛收官战爆冷，黑马战队让二追三逆袭夺冠", category: "体育赛场" },
  { id: "l6", date: "09-09", time: "11:30", title: "新能源车价格区间再调整，普通家庭该如何挑选", category: "财经速览" },
];

export const faqs = [
  {
    q: "“看料入口”里的内容主要来自哪里？",
    a: "站内内容由编辑团队围绕公开可查的资讯线索进行整理与二次撰写，重点做的是分类、摘要与来龙去脉的梳理，让读者不用在多个页面之间来回跳转。",
  },
  {
    q: "为什么打开就能看，不需要注册登录？",
    a: "我们把这个入口定位为「浏览型门户」，绝大多数内容无需登录即可阅读。只有在后续推出收藏、订阅等个性化功能时，才可能引导你创建账号。",
  },
  {
    q: "分类浏览里的标签可以组合筛选吗？",
    a: "可以。你可以在「分类浏览」区域切换主题标签，也可以直接在首屏搜索框输入关键词，系统会同时匹配标题、摘要与分类，并只展示命中的内容。",
  },
  {
    q: "内容多久更新一次？",
    a: "热点与娱乐分区保持每日多次更新，生活、科技、财经与体育分区按各自节奏更新。「最新更新」区域会按时间倒序展示最近发布的内容。",
  },
  {
    q: "怎样第一时间看到新料？",
    a: "建议收藏本站并从首屏搜索框直接进入感兴趣的分区；你也可以在页脚留下邮箱，后续开放订阅功能时会优先通知你。",
  },
  {
    q: "如果发现内容有误，可以反馈吗？",
    a: "欢迎反馈。你可以通过页脚的邮箱联系编辑团队，注明具体内容标题与问题点，我们会尽快核实并修正。",
  },
];

export const testimonials = [
  {
    id: "t1",
    name: "林一 · 通勤族",
    content:
      "以前找内容要点开一堆页面，现在打开这个入口直接在分类里点，省下的时间够我多睡十分钟。",
  },
  {
    id: "t2",
    name: "周可 · 内容编辑",
    content:
      "摘要写得挺实在，不夸张也不拖沓，做选题的时候翻这里的分类比翻收藏夹快多了。",
  },
  {
    id: "t3",
    name: "陈默 · 数码爱好者",
    content:
      "科技分区讲得清楚，新机升级点直接列出来，不用自己再去对比参数表。",
  },
  {
    id: "t4",
    name: "苏婉 · 学生",
    content:
      "界面干净，没有乱七八糟的弹窗，搜关键词直接出结果，学校宿舍网也能秒开。",
  },
];

export const aboutValues = [
  {
    icon: "ri-compass-3-line",
    title: "入口优先",
    desc: "把「怎么最快抵达」放在第一位，减少层级与跳转，让浏览路径短而清楚。",
  },
  {
    icon: "ri-shield-check-line",
    title: "内容克制",
    desc: "不堆砌夸张标题，摘要如实概括，重点信息前置，读完就能判断值不值得展开。",
  },
  {
    icon: "ri-refresh-line",
    title: "持续更新",
    desc: "热点与娱乐每日多次更新，其余分区按节奏跟进，避免出现长期不动的僵尸栏目。",
  },
  {
    icon: "ri-user-voice-line",
    title: "读者共建",
    desc: "欢迎指出错漏与选题建议，合理的反馈会被纳入下一轮整理计划。",
  },
];